module.exports = __webpack_public_path__ + "fonts/53f16cfdf5969f0b7e3510268e4da2b6.svg";